import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

/**
 * Render trusted-by-editor HTML safely. Strips scripts/onclick/etc. via DOMPurify.
 * Also handles legacy plain-text / markdown-ish content by escaping if no tags present.
 */
const SafeHtml = ({ html, className = '', testId }) => {
  const sanitized = useMemo(() => {
    if (!html) return '';
    const looksLikeHtml = /<\w+[\s>\/]/.test(html);
    if (!looksLikeHtml) {
      // Treat as plain text: escape, preserve newlines
      const esc = html
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/\n/g, '<br/>');
      return DOMPurify.sanitize(esc);
    }
    return DOMPurify.sanitize(html, {
      ADD_ATTR: ['target', 'rel'],
    });
  }, [html]);

  return (
    <div
      className={`md-content ${className}`}
      data-testid={testId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export default SafeHtml;
